import { Component } from "react";

// Without this, an uncaught render error anywhere in the tree (a stray DOM
// mutation from a browser extension, a race during login, etc.) unmounts the
// whole app silently — the user is left staring at the near-black page
// background with nothing on it, which reads as "the screen is black/broken"
// with no way to recover short of knowing to hit F5.
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Metazik crashed:", error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="min-h-screen grid place-items-center px-6 text-center bg-black text-white">
        <div>
          <h2 className="text-xl font-bold">Une erreur est survenue</h2>
          <p className="mt-2 text-sm text-zinc-400">
            Recharge la page pour continuer.
          </p>
          <button
            onClick={() => window.location.reload()}
            className="mt-6 px-6 py-2 rounded-full bg-white text-black font-bold text-sm"
          >
            Recharger
          </button>
        </div>
      </div>
    );
  }
}
